import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Pill, Footprints } from 'lucide-react';
const pillars = [{
  number: '01',
  title: 'The 30g Protein Floor',
  icon: Shield,
  description: "No meal enters your body without 30g of real protein. This isn't for 'muscle'—it's a chemical bumper. It triggers natural GLP-1 and turns a 'Glucose Ferrari' (carbs) into a slow-moving freight truck.",
  highlight: 'Glucose Ferrari'
}, {
  number: '02',
  title: 'CGM-Linked Carb Caps',
  icon: Pill,
  description: "Stop guessing. Use your Stelo, Lingo, or Dexcom like a GPS. If you cross the 140 mg/dL line, your protocol failed. We show you how to find your 'Official Fuels' (Is it rice? Is it potato? Your blood will tell you).",
  highlight: 'Official Fuels'
}, {
  number: '03',
  title: "The 15-Minute 'Sump Pump' Trigger",
  icon: Footprints,
  description: '15 minutes after your last bite, you walk. This activates GLUT4 transporters that vacuum sugar out of your blood before it stains your A1C.',
  highlight: 'GLUT4 transporters'
}];
export function ThreePillars() {
  return <section className="w-full py-24 px-4 bg-[#161616] border-y border-gray-800" data-id="element-219">
      <div className="max-w-6xl mx-auto" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wide mb-4" data-id="element-222">
            The 3-Number Control Panel
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-223">
            Three non-negotiable intercepted strikes to reclaim your metabolic
            control.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-224">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-[#111111] border border-gray-800 p-8 rounded-xl relative group hover:border-accent/50 transition-colors duration-300" data-id="element-225">
              {/* Number Watermark */}
              <div className="absolute top-4 right-4 text-6xl font-bold text-gray-800/30 font-sans select-none" data-id="element-226">
                {pillar.number}
              </div>

              {/* Icon */}
              <div className="w-16 h-16 rounded-full bg-gray-900 border border-gray-700 flex items-center justify-center mb-6 group-hover:border-accent group-hover:bg-accent/10 transition-all duration-300" data-id="element-227">
                <pillar.icon className="w-8 h-8 text-white group-hover:text-accent transition-colors duration-300" data-id="element-228" />
              </div>

              <h3 className="text-xl font-bold text-white mb-4 uppercase tracking-wide" data-id="element-229">
                {pillar.title}
              </h3>

              <p className="text-gray-400 leading-relaxed" data-id="element-230">
                {pillar.description.split(pillar.highlight).map((part, i, arr) => <span key={i} data-id="element-231">
                      {part}
                      {i < arr.length - 1 && <span className="text-accent font-semibold" data-id="element-232">
                          {pillar.highlight}
                        </span>}
                    </span>)}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}